<template>
  <div
    v-if="
      selectedBot &&
      (!selectedBot.pagerole || (selectedBot.pagerole && selectedBot.pagerole == 'admin'))
    "
    class="template"
  >
    <main-layout>
      <template v-if="!loading">
        <template v-if="themeExist">
          <component :is="currentView"></component>
        </template>
        <template v-else>
          <component :is="'template-reporter'"></component>
        </template>
      </template>
    </main-layout>
  </div>
</template>

<script>
import reporter from '@/components/view/template/reporter/reporter'
import ecommerce from '@/components/view/template/ecommerce/ecommerce'
import event from '@/components/view/template/event/Event'
import qualityexpress from '@/components/view/template/qualityexpress/main'
import leologistics from '@/components/view/template/leologistics/main'
import dplus from '@/components/view/template/dplus/main'
import runbetter from '@/components/view/template/runbetter/main'
import bblcareer from '@/components/view/template/bblcareer/main'
import { mapGetters, mapMutations } from 'vuex'

export default {
  // name: 'template',
  components: {
    'template-reporter': reporter,
    'template-ecommerce': ecommerce,
    'template-event': event,
    'template-qualityexpress': qualityexpress,
    'template-leologistics': leologistics,
    'template-dplus': dplus,
    'template-runbetter': runbetter,
    'template-bblcareer': bblcareer
  },
  data: function () {
    return {
      // currentView: 'template-reporter'
      themeExist: false,
      loading: true,
      themes: [
        'bec',
        'reporter',
        'ecommerce',
        'sahapan',
        'ecommercebasic',
        'chatty',
        'event',
        'qualityexpress',
        'leologistics',
        'dplus',
        'runbetter',
        'nvbb',
        'ticket',
        'bblcareer'
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currentView: function () {
      if (!this.$store.state.selectedBot) {
        return null
      }
      let theme = this.$store.state.selectedBot.theme

      if (this.$store.state.shoptheme.includes(theme)) {
        return 'template-ecommerce'
      } else {
        return 'template-' + theme
      }
    }
  },
  mounted: function () {
    let vm = this
    $.each(vm.themes, function (index, value) {
      if (value == vm.$store.state.selectedBot.theme) {
        vm.themeExist = true
        vm.loading = false
        return false
      }
    })
    vm.loading = false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/template.vue